module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"AIRun.Art","short_name":"AIRun","start_url":"/","background_color":"#050038","theme_color":"#050038","display":"standalone","description":"AIRun.Art — сервис для автоматизации создания фото карточек товаров с помощью нейросетей.","icon":"static/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c29cb7b6267c21534e9fb5582eee8251"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
